import { Link } from "react-router-dom";
import { Clock, Phone, Siren, Star } from "lucide-react";
import { LogoMark } from "./Logo";
import { SERVICES } from "@/data/services";
import { AREAS } from "@/data/areas";
import { SITE } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-slate-300" data-testid="site-footer">
      <div className="h-1.5 bg-brand-red" />
      <div className="container-x grid gap-12 py-16 md:py-20 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3">
            <LogoMark className="h-10" light />
            <span className="font-display text-xl font-extrabold tracking-tight text-white">
              FUSION <span className="font-bold text-brand-red">GLASS</span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Premium custom glass solutions for residential and commercial projects across Sydney.
            Made to measure, compliant with Australian Standard AS 1288, guaranteed workmanship.
          </p>
          <p className="mt-5 font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
            Framing Sydney, one panel at a time
          </p>
        </div>

        <div className="lg:col-span-5">
          <p className="eyebrow mb-5">Our services</p>
          <div className="grid grid-cols-1 gap-x-8 gap-y-2 sm:grid-cols-2">
            {SERVICES.map((s) => (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="text-sm text-slate-400 transition-colors hover:text-white"
                data-testid={`footer-service-${s.slug}`}
              >
                {s.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="eyebrow mb-5">Get in touch</p>
          <div className="space-y-4 text-sm">
            <a href={`tel:${SITE.phoneMain}`} className="flex items-center gap-3 text-white transition-colors hover:text-brand-red" data-testid="footer-call-btn">
              <Phone className="h-4 w-4 text-brand-red" /> {SITE.phoneMainDisplay}
            </a>
            <a href={`tel:${SITE.phoneEmergency}`} className="flex items-center gap-3 text-red-300 transition-colors hover:text-red-200" data-testid="footer-emergency-btn">
              <Siren className="h-4 w-4" /> {SITE.phoneEmergencyDisplay}
              <span className="text-xs text-slate-500">- 24/7 emergencies</span>
            </a>
            <p className="flex items-center gap-3 text-slate-400">
              <Clock className="h-4 w-4 text-brand-red" /> {SITE.hours}
            </p>
            <a
              href={SITE.reviewUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-xs font-bold text-white transition-colors hover:border-brand-red hover:text-brand-red"
              data-testid="footer-leave-review-btn"
            >
              <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" /> Leave us a Google review
            </a>
            <p className="text-xs leading-relaxed text-slate-500">
              Servicing all of Greater Sydney -{" "}
              {AREAS.map((a, i) => (
                <span key={a.slug}>
                  <Link to={`/areas/${a.slug}`} className="transition-colors hover:text-white" data-testid={`footer-area-${a.slug}`}>
                    {a.name}
                  </Link>
                  {i < AREAS.length - 1 ? ", " : "."}
                </span>
              ))}
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6">
        <p className="container-x text-xs text-slate-500">
          (c) {new Date().getFullYear()} Fusion Glass - Sydney glass solutions. Glass Pool Fencing, Balustrades, Shower
          Screens, Mirrors, Splashbacks &amp; Emergency Glazing.
        </p>
      </div>
    </footer>
  );
}
